// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discount[data-v-114afbc2]{color:#ff7272}hr[data-v-114afbc2]{border-top:1px solid #c1c1c1}", ""]);
// Exports
module.exports = exports;
